exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-cropper-container {\n  overflow: hidden;\n  height: 240px;\n  margin-bottom: 1rem;\n  line-height: 240px;\n  text-align: center;\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\"); }\n  .image-cropper-container .image-cropper-picture {\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    width: 230px;\n    margin-bottom: 5px; }\n\n.image-cropper-btn-group-wrap {\n  text-align: center; }\n\n.image-cropper-inner-wrap .cropper-view-box, .image-cropper-inner-wrap .cropper-face {\n  border-radius: 50%;\n  border: 1px solid #67D4F4; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/image-cropper/image-cropper.component.scss
// module id = ../../../../../src/app/components/image-cropper/image-cropper.component.scss
// module chunks = main